<!--<template>-->
<!--  <div class="base-right-side-modal">-->
<!--    <transition name="modal-animation" appear>-->
<!--      <div v-show="isModalOpen" :id="modalId ? `${modalId}` : 'base-right-side-modal'" class="modal-container">-->
<!--        <div class="modal-backdrop-container" @click="$emit('hide')"></div>-->
<!--        <div class="content-container">-->
<!--          <transition name="modal-animation-inner" appear appear-class="custom-appear">-->
<!--            <div v-show="isModalOpen" class="modal-inner">-->
<!--              &lt;!&ndash; Modal header &ndash;&gt;-->
<!--              <div v-if="!hideHeader" class="modal-header">-->
<!--                <slot name="modal-header"></slot>-->
<!--              </div>-->
<!--              &lt;!&ndash; Modal body &ndash;&gt;-->
<!--              <div class="modal-body">-->
<!--                <slot name="modal-body"></slot>-->
<!--              </div>-->
<!--              &lt;!&ndash; Modal footer &ndash;&gt;-->
<!--              <div v-if="!hideFooter" class="modal-footer justify-content-center">-->
<!--                <slot name="modal-footer"></slot>-->
<!--              </div>-->
<!--            </div>-->
<!--          </transition>-->
<!--        </div>-->
<!--      </div>-->
<!--    </transition>-->
<!--  </div>-->
<!--</template>-->

<!--<script setup lang="ts">-->
<!--interface Props {-->
<!--  modalId?: string;-->
<!--  hideFooter?: boolean;-->
<!--  hideHeader?: boolean;-->
<!--  isModalOpen: boolean;-->
<!--}-->

<!--defineProps<Props>();-->
<!--defineEmits(['hide']);-->
<!--</script>-->

<!--<style style lang="scss" scoped>-->
<!--@import '@/assets/styles/base/base-right-side-modal.scss';-->
<!--</style>-->

<!--<template>-->
<!--  <transition name="modal-animation" appear>-->
<!--    <div :id="modalId || 'base-right-side-modal'" :class="['modal', 'base-right-side-modal']" tabindex="-1" aria-modal="true" ref="modalRef">-->
<!--      <div class="modal-dialog modal-dialog-right" role="dialog">-->
<!--        <transition name="modal-animation-inner" appear>-->
<!--          <div v-if="isModalOpen" class="modal-content">-->
<!--            &lt;!&ndash; Modal header &ndash;&gt;-->
<!--            <div v-if="!hideHeader" class="modal-header">-->
<!--              <slot name="modal-header"></slot>-->
<!--            </div>-->
<!--            &lt;!&ndash; Modal body &ndash;&gt;-->
<!--            <div class="modal-body">-->
<!--              <slot name="modal-body"></slot>-->
<!--            </div>-->
<!--            &lt;!&ndash; Modal footer &ndash;&gt;-->
<!--            <div v-if="!hideFooter" class="modal-footer justify-content-center">-->
<!--              <slot name="modal-footer"></slot>-->
<!--            </div>-->
<!--          </div>-->
<!--        </transition>-->
<!--      </div>-->
<!--    </div>-->
<!--  </transition>-->
<!--</template>-->

<!--<script setup lang="ts">-->
<!--import { onMounted, watch, ref, onUnmounted } from 'vue';-->
<!--import { Modal } from 'bootstrap';-->

<!--interface Props {-->
<!--  modalId?: string;-->
<!--  hideFooter?: boolean;-->
<!--  hideHeader?: boolean;-->
<!--  isModalOpen: boolean;-->
<!--}-->

<!--const props = defineProps<Props>();-->
<!--const emits = defineEmits(['hide']);-->
<!--const modalRef = ref<HTMLElement | null>(null);-->
<!--let modalInstance: Modal | null = null;-->

<!--// Close modal and emit hide event-->
<!--const closeModal = () => {-->
<!--  if (modalInstance) modalInstance.hide();-->
<!--  emits('hide');-->
<!--};-->

<!--// Watch for changes in isModalOpen prop-->
<!--watch(-->
<!--  () => props.isModalOpen,-->
<!--  (newVal) => {-->
<!--    if (modalInstance) {-->
<!--      newVal ? modalInstance.show() : modalInstance.hide();-->
<!--    }-->
<!--  },-->
<!--  { immediate: true },-->
<!--);-->

<!--onMounted(() => {-->
<!--  if (modalRef.value) {-->
<!--    modalInstance = new Modal(modalRef.value, {-->
<!--      backdrop: 'static',-->
<!--      keyboard: true,-->
<!--    });-->

<!--    modalRef.value.addEventListener('hidden.bs.modal', closeModal);-->
<!--  }-->

<!--  if (props.isModalOpen && modalInstance) {-->
<!--    modalInstance.show();-->
<!--  }-->
<!--});-->

<!--onUnmounted(() => {-->
<!--  modalInstance?.dispose();-->
<!--});-->
<!--</script>-->

<!--<style scoped lang="scss">-->
<!--@import '@/assets/styles/base/base-right-side-modal.scss';-->
<!--</style>-->

<!--<template>-->
<!--  <transition name="modal-animation" appear>-->
<!--    <div :id="modalId || 'full-height-side-modal'" :class="['modal', 'full-height-side-modal']" tabindex="-1" aria-modal="true" ref="modalRef">-->
<!--      <div class="modal-dialog modal-dialog-full-height modal-dialog-right" role="dialog">-->
<!--        <transition name="modal-animation-inner" appear>-->
<!--          <div v-if="isModalOpen" class="modal-content">-->
<!--            &lt;!&ndash; Modal header &ndash;&gt;-->
<!--            <div v-if="!hideHeader" class="modal-header">-->
<!--              <slot name="modal-header" />-->
<!--              <div v-if="$slots['modal-action']" class="modal-action-wrp">-->
<!--                <slot name="modal-action" />-->
<!--              </div>-->
<!--            </div>-->
<!--            &lt;!&ndash; Modal body &ndash;&gt;-->
<!--            <div class="modal-body">-->
<!--              <slot name="modal-body" />-->
<!--            </div>-->
<!--          </div>-->
<!--        </transition>-->
<!--      </div>-->
<!--    </div>-->
<!--  </transition>-->
<!--</template>-->

<!--<script setup lang="ts">-->
<!--import { onMounted, watch, ref, onUnmounted } from 'vue';-->
<!--import { Modal } from 'bootstrap';-->

<!--interface Props {-->
<!--  modalId?: string;-->
<!--  hideHeader?: boolean;-->
<!--  isModalOpen: boolean;-->
<!--}-->

<!--const props = defineProps<Props>();-->
<!--const emits = defineEmits(['hide']);-->
<!--const modalRef = ref<HTMLElement | null>(null);-->
<!--let modalInstance: Modal | null = null;-->

<!--// Close modal and emit hide event-->
<!--const closeModal = () => {-->
<!--  if (modalInstance) modalInstance.hide();-->
<!--  emits('hide');-->
<!--};-->

<!--// Watch for changes in isModalOpen prop-->
<!--watch(-->
<!--  () => props.isModalOpen,-->
<!--  (newVal) => {-->
<!--    if (modalInstance) {-->
<!--      newVal ? modalInstance.show() : modalInstance.hide();-->
<!--    }-->
<!--  },-->
<!--  { immediate: true },-->
<!--);-->

<!--onMounted(() => {-->
<!--  if (modalRef.value) {-->
<!--    modalInstance = new Modal(modalRef.value, {-->
<!--      backdrop: 'static',-->
<!--      keyboard: true,-->
<!--    });-->

<!--    modalRef.value.addEventListener('hidden.bs.modal', closeModal);-->

<!--  }-->

<!--  if (props.isModalOpen && modalInstance) {-->
<!--    modalInstance.show();-->
<!--  }-->
<!--});-->

<!--onUnmounted(() => {-->
<!--  modalInstance?.dispose();-->
<!--});-->
<!--</script>-->

<!--<style scoped lang="scss">-->
<!--@import '@/assets/styles/base/base-right-side-modal.scss';-->

<!--.full-height-side-modal {-->
<!--  position: fixed;-->
<!--  top: 0;-->
<!--  right: 0;-->
<!--  height: 100%;-->
<!--  width: 40vw;-->
<!--  min-width: 400px;-->
<!--  margin-left: calc(100% - 40vw);-->
<!--  max-width: 100%;-->
<!--  overflow: hidden;-->
<!--}-->

<!--.modal-dialog-full-height {-->
<!--  height: 100%;-->
<!--  margin: 0;-->
<!--}-->

<!--.modal-dialog-right {-->
<!--  position: absolute;-->
<!--  right: 0;-->
<!--}-->

<!--.modal-dialog {-->
<!--  max-width: 50vw;-->
<!--}-->

<!--.modal-header {-->
<!--  width: 100%;-->

<!--  .modal-action-wrp {-->
<!--    margin-left: auto;-->
<!--  }-->
<!--}-->

<!--.modal-content {-->
<!--  height: 100%;-->
<!--  border-radius: 0;-->
<!--}-->
<!--</style>-->

<template>
  <transition name="offcanvas-animation" appear>
    <div
      :id="modalId"
      :class="['offcanvas', 'full-height-side-offcanvas', 'offcanvas-end']"
      tabindex="-1"
      aria-labelledby="offcanvasRightLabel"
      ref="offcanvasRef"
    >
      <div class="offcanvas-header" v-if="!hideHeader">
        <div v-if="$slots['modal-header']" class="modal-title">
          <button class="btn btn-light me-2" @click="closeOffcanvas">X</button>
          <slot name="modal-header" />
        </div>

        <div v-if="$slots['modal-action']" class="modal-action">
          <slot name="modal-action" />
        </div>
      </div>
      <div class="offcanvas-body">
        <slot name="modal-body" />
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { onMounted, watch, ref, onUnmounted } from 'vue';
import { Offcanvas } from 'bootstrap';

interface Props {
  modalId?: string;
  hideHeader?: boolean;
  isModalOpen: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  modalId: 'base-right-side-modal',
  isModalOpen: false,
  hideHeader: false,
});
const emits = defineEmits(['hide']);
const offcanvasRef = ref<HTMLElement | null>(null);
let offcanvasInstance: Offcanvas | null = null;

// Close offcanvas and emit hide event
const closeOffcanvas = () => {
  if (offcanvasInstance) {
    offcanvasInstance.hide();
    emits('hide');
  }
};

// Watch for changes in isModalOpen prop
watch(
  () => props.isModalOpen,
  (newVal) => {
    if (offcanvasInstance) {
      newVal ? offcanvasInstance.show() : offcanvasInstance.hide();
    }
  },
  { immediate: true },
);

onMounted(() => {
  if (offcanvasRef.value) {
    offcanvasInstance = new Offcanvas(offcanvasRef.value, {
      backdrop: true,
      keyboard: true,
    });

    offcanvasRef.value.addEventListener('hidden.bs.offcanvas', closeOffcanvas);
  }

  if (props.isModalOpen && offcanvasInstance) {
    offcanvasInstance.show();
  }
});

onUnmounted(() => {
  offcanvasInstance?.dispose();
});
</script>

<style scoped lang="scss">
@import '@/assets/styles/base/base-right-side-modal.scss';

.btn {
  border: 0px solid;
  border-radius: 10px;
  width: 40px;
  height: 40px;
}

.full-height-side-offcanvas {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 50vw;
  min-width: 400px;
  max-width: 50vw;
  z-index: 1050;
  overflow: hidden;
  outline: 0;
}

.offcanvas.offcanvas-end {
  border-left-width: 0;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  padding: 1rem;
  width: -webkit-fill-available;
}

.offcanvas-header {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.offcanvas-body {
  height: 100%;
  overflow-y: auto;
  padding: 1rem;
}

.offcanvas-header {
  align-items: center;

  .modal-title {
    display: flex;
    align-items: center;
    width: 100%;

    &:has(~ .modal-action) {
      flex: 2;
    }
  }

  .modal-action {
    display: inline-flex;
    text-align: right;
  }
}
</style>
